import * as React from 'react';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var IconFileEps = function IconFileEps(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M31 15V35C31 37.2091 29.2091 39 27 39H5C2.79086 39 1 37.2091 1 35V5C1 2.79086 2.79086 1 5 1H17",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 15V1L31 15H17Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68 30.9595H10.32V29.6795H7.68V27.8395H11.04V26.4795H6V34.2395H11.2V32.8795H7.68V30.9595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0404 26.4795H12.4004V34.2395H14.1604V31.4395H15.1204C16.8804 31.4395 18.0004 30.6395 18.0004 29.0395V28.9595C18.0004 27.2795 16.9604 26.4795 15.0404 26.4795ZM16.3204 28.9595C16.3204 29.7595 15.8404 30.1595 15.0404 30.1595H14.1604V27.7595H15.0404C15.8404 27.8395 16.3204 28.1595 16.3204 28.9595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9206 29.5211C20.7206 29.3611 20.4806 29.1211 20.4806 28.5611C20.4806 28.0811 20.8806 27.6811 21.6006 27.6811C22.4006 27.6811 22.8006 28.0011 22.8806 28.7211H24.4806C24.4006 27.1211 23.3606 26.4011 21.6806 26.4011C20.0006 26.4011 18.8806 27.3611 18.8806 28.7211C18.8806 30.2411 19.6806 30.8011 21.6806 31.0411C22.8006 31.2011 23.1206 31.4411 23.1206 32.0811C23.1206 32.7211 22.6406 33.1211 21.8406 33.1211C20.7206 33.1211 20.4006 32.5611 20.3206 31.8411H18.6406C18.7206 33.3611 19.6806 34.4011 21.8406 34.4011C23.6806 34.4011 24.8006 33.2811 24.8006 31.9211C24.7206 30.2411 23.7606 29.7611 21.9206 29.5211Z",
    fill: "black"
  }));
};

export { IconFileEps };